import * as React from "react";
import Table from "@material-ui/core/Table";
import { TablePagination } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import firebase from "firebase";
import { makeStyles } from "@material-ui/core";

const jobCategories = {
  swe: "Software Engineering",
  ds: "Data Science",
  pm: "Product Manager",
  qr: "Quant",
  ml: "Machine Learning",
  ba: "Business Analytics",
  other: "Other",
};

const invJobCategories = {
  "Software Engineering": "swe",
  "Data Science": "ds",
  "Product Manager": "pm",
  Quant: "qr",
  "Machine Learning": "ml",
  "Business Analytics": "ba",
  Other: "other",
};
function InterviewQuestions(props) {
  const useStyles = makeStyles((theme) => ({
    table: {
      marginTop: theme.spacing(3),
      "& thead th": {
        fontWeight: "600",
        color: theme.palette.primary.main,
        // backgroundColor: theme.palette.primary.light,
      },
      "& tbody td": {
        fontWeight: "300",
      },
      "& tbody tr:hover": {
        backgroundColor: "#fffbf2",
        cursor: "pointer",
      },
    },
  }));
  const styles = useStyles();
  const [questions, setQuestions] = React.useState([]);
  const [headCells, setHeadCells] = React.useState([
    {
      className: "colName",
      align: "left",
      style: { fontWeight: "bold" },
      displayName: "Stage",
      id: "name",
    },
    {
      className: "colName",
      align: "left",
      style: { fontWeight: "bold" },
      displayName: "Type",
      id: "job",
      // disableSorting: true,
    },
    {
      className: "colName",
      align: "left",
      style: { fontWeight: "bold" },
      displayName: "Question",
      id: "status",
    },
  ]);
  React.useEffect(() => {
    firebase
      .firestore()
      .collection(invJobCategories[props.displaycategory])
      .doc(props.companyid)

      .get()
      .then((doc) => {
        if (doc.exists) {
          const data = doc.data();
          const qfb = data["questions"] ? data["questions"] : [];
          const res = [];
          for (const q of qfb) {
            if (q.isPublic) res.push(q);
          }
          setQuestions(res);
        }
      });
  }, []);

  return (
    <div>
      <Table className={styles.table} style={{}} aria-label="simple table">
        <TableHead>
          <TableRow className="colNames">
            {headCells.map((obj) => (
              <TableCell>{obj.displayName}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {questions.map((q) => {
            return (
              <TableRow className="colNames">
                <TableCell>{q.stage}</TableCell>
                <TableCell>{q.type}</TableCell>
                <TableCell>{q.question}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

export default InterviewQuestions;
